import { FormGroup, FormControl, ValidatorFn, ValidationErrors, AbstractControl, FormArray } from "@angular/forms";

// To validate password and confirm password
export function DateAfterTodayValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const today = new Date().getDate();

    if (!(control && control.value)) {
      // if there's no control or no value, that's ok
      return null;
    }

    // return null if there's no errors
    return control.value.getDate() < today
      ? { invalidDate: 'Data final não pode ser anterior à data de hoje' }
      : null;
  }
}

export function DateStringNotBeforeToday(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control || !control.value) {
      return null; // Valor vazio, não precisa validar
    }

    let dateString = control.value.toString().replaceAll("/", "");
    let darr = dateString.split("");//["2", "9", "0", "1", "2", "0", "1", "6"]
    let selectedDate = new Date(parseInt(darr[4] + darr[5] + darr[6] + darr[7]), parseInt(darr[2] + darr[3]) - 1, parseInt(darr[0] + darr[1]));
    selectedDate.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedDate < today) {
      return { 'dateBeforeToday': true };
    }

    return null;
  };
}

export function DateValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control || !control.value) {
      return null; // Valor vazio, não precisa validar
    }

    if (control.value instanceof Date) {
      return isNaN(control.value.getTime()) || control.value.getFullYear() < 1800 ? { 'invalidFormat': true } : null;
    }

    const value = control.value.toString().replaceAll("/", "");

    // Verifica se o valor é uma string no formato DD/MM/YYYY
    const DATE_REGEXP = /^\d{2}\d{2}\d{4}$/;

    if (!DATE_REGEXP.test(value)) {
      return { 'invalidFormat': true }; // Formato inválido
    }

    // Verifica se a data é válida
    const day = parseInt(value.substring(0, 2), 10);
    const month = parseInt(value.substring(2, 4), 10) - 1; // Mês é base zero
    const year = parseInt(value.substring(4), 10);
    const date = new Date(year, month, day);
    if (
      date.getDate() !== day ||
      date.getMonth() !== month ||
      date.getFullYear() !== year ||
      (date.getFullYear() === year && date.getFullYear() < 1800)
    ) {
      return { 'invalidDate': true }; // Data inválida
    }

    return null; // Data válida
  }
}

// Validar se a data é válida e não é anterior a hoje
export function ValidatePastDate(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control || !control.value) {
      return null;
    }

    const dateString = control.value.toString().replaceAll("/", "");

    if (!/^\d{8}$/.test(dateString)) {
      return { invalidDate: 'Data inválida' };
    }

    const day = parseInt(dateString.substring(0, 2), 10);
    const month = parseInt(dateString.substring(2, 4), 10);
    const year = parseInt(dateString.substring(4, 8), 10);

    if (month < 1 || month > 12 || day < 1 || year < 1) {
      return { invalidDate: 'Data inválida' };
    }

    const selectedDate = new Date(year, month - 1, day);
    selectedDate.setHours(0, 0, 0, 0);

    if (selectedDate.getFullYear() !== year ||
      selectedDate.getMonth() !== month - 1 ||
      selectedDate.getDate() !== day) {
      return { invalidDate: 'Data inválida' };
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedDate < today) {
      return { invalidDate: 'Data não pode ser anterior à data de hoje' };
    }

    return null;
  };
}

//Validar se a data é maior uqe hoje
export function ValidateFutureDate(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control || !control.value) {
      return null; // Valor vazio, não precisa validar
    }

    let dateString = control.value.toString().replaceAll("/", "");
    let darr = dateString.split("");//["2", "9", "0", "1", "2", "0", "1", "6"]
    let selectedDate = new Date(parseInt(darr[4] + darr[5] + darr[6] + darr[7]), parseInt(darr[2] + darr[3]) - 1, parseInt(darr[0] + darr[1]));
    selectedDate.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedDate > today) {
      return { invalidDate: 'Data não pode ser posterior à data de hoje' };
    }

    return null;
  };
}

export function startDateValidator(control: AbstractControl): ValidationErrors | null {
  const selectedDate = control.value;
  const minDate = new Date(2025, 3, 1);
  return selectedDate && selectedDate < minDate ? { minDate: true } : null;
}
